import { render, staticRenderFns } from "./ItemCheckboxes.vue?vue&type=template&id=116b8522&scoped=true&"
import script from "./ItemCheckboxes.vue?vue&type=script&lang=js&"
export * from "./ItemCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./ItemCheckboxes.vue?vue&type=style&index=0&id=116b8522&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116b8522",
  null
  
)

export default component.exports